import { render, staticRenderFns } from "./VProjectHeaderTitle.vue?vue&type=template&id=66658cd5&scoped=true&"
import script from "./VProjectHeaderTitle.vue?vue&type=script&lang=ts&"
export * from "./VProjectHeaderTitle.vue?vue&type=script&lang=ts&"
import style0 from "./VProjectHeaderTitle.vue?vue&type=style&index=0&id=66658cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66658cd5",
  null
  
)

export default component.exports